import gql from "graphql-tag";

export const createProductReview = gql`
  mutation CreateProductReview(
    $comment: String!
    $value: Int!
    $userName: String!
    $userEmail: String!
    $productId: Int!
    $businessUnit: String!
  ) {
    createProductReview(
      comment: $comment
      value: $value
      userName: $userName
      userEmail: $userEmail
      productId: $productId
      businessUnit: $businessUnit
    ) {
      id
      comment
      userId
      userName
      value
    }
  }
`;
